import URI from 'urijs';
import * as c from 'utils/constants/constants';
import { MiddlewareAPI } from 'redux';
import { openDialog } from 'utils/officeJS/dialogUtils';
import { NO_OFFICE } from 'utils/constants/constants';
import { browserInfo } from 'utils/browserUtils';

const OPEN_LOGIN_PAGE_ACTION = 'loginState/openLoginPage';

const loginMiddleware = (store: MiddlewareAPI) => (next: any) => (action: any) => {
  if (action.type !== OPEN_LOGIN_PAGE_ACTION) return next(action);
  const url = new URI(`?action=${c.LOGIN_ACTION}`).absoluteTo(window.location.toString()).toString();
  const dialogUrl = `${c.loginAppUrl}${url}`;
  NO_OFFICE ? window.location.assign(dialogUrl) : openDialog(dialogUrl, browserInfo.safari, false, store.dispatch);
  return next(action);
};

export default loginMiddleware;
